import { render, staticRenderFns } from "./vertaalainaa.vue?vue&type=template&id=37715b19&"
import script from "./vertaalainaa.vue?vue&type=script&lang=js&"
export * from "./vertaalainaa.vue?vue&type=script&lang=js&"
import style0 from "./vertaalainaa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports